import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { analyticsApi, type IntelligenceRecommendation } from '../../api/analytics';

export function DecisionCenterPage() {
  const [recs, setRecs] = useState<IntelligenceRecommendation[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void analyticsApi.listRecommendations('default').then(setRecs).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Decision Center</h1>
        <Link to="/analytics/bi" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← BI Hub</Link>
      </div>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Business recommendations, scenario planning and decision intelligence.</p>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 space-y-3">
        {recs.map((r) => (
          <div key={r.id} className="rounded-xl border p-4 dark:border-slate-700">
            <div className="flex items-start justify-between">
              <p className="font-medium">{r.title}</p>
              <span className="rounded-full bg-brand-50 px-2 py-0.5 text-xs text-brand-700 dark:bg-brand-950 dark:text-brand-300">{r.priority}</span>
            </div>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{r.description}</p>
            <p className="mt-2 text-sm font-medium">{r.suggested_action}</p>
            <p className="mt-1 text-xs text-slate-500">Impact: ₹{(r.estimated_impact ?? 0).toLocaleString()} · Confidence: {((r.confidence ?? 0) * 100).toFixed(0)}%</p>
          </div>
        ))}
      </div>
    </div>
  );
}
